import AttendanceRollup from '@/components/attendance-rollup/AttendanceRollup'

function Reports() {
  return <AttendanceRollup />
}

export default Reports
